module.exports = __webpack_public_path__ + "static/media/scan.36f29444.png";